<template>
	<Autocomplete
		:icon="icon"
		:item-value="permission ? 'task_type_id' : 'id'"
		item-title="name"
		:label="label"
		:endpoint="endpoint"
		:name="name"
		display-name="Wiedervorlage Art(en)"
		data-test="task_types-autocomplete"
		v-bind="$attrs"
	>
		<template #item="{ item, props }">
			<v-list-item
				v-bind="props"
				:title="`${item.raw.hp_id} - ${item.raw.name}`"
			>
			</v-list-item>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '../Validation/Autocomplete.vue'

defineProps({
	icon: {
		default: 'fa-fw fa-solid fa-clipboard-list-check',
		type: String,
	},
	label: {
		default: 'component.tasks.taskType',
		type: String,
	},
	name: {
		default: 'taskType',
		type: String,
	},
	endpoint: {
		default: 'task_types',
		type: String,
	},
	permission: {
		default: false,
		type: Boolean,
	},
})
</script>

<style scoped></style>
